import { loadCourse, resolveMediaUrl } from "../utils/Network";
import parse from "html-react-parser";
import { useState } from "react";
import {
  migrateKurdishTalentPublicAuth,
  KT_AUTH_TOKEN_KEY,
  KT_AUTH_USER_KEY,
} from "./authStorageKeys";

migrateKurdishTalentPublicAuth();

export const logout = () => {
  removeUserSession();
};

export const isLogin = () => {
  migrateKurdishTalentPublicAuth();
  if (localStorage.getItem(KT_AUTH_TOKEN_KEY)) {
    return true;
  }
  return false;
};

// return the user data from the session storage
export const getUser = () => {
  migrateKurdishTalentPublicAuth();
  const userStr = localStorage.getItem(KT_AUTH_USER_KEY);
  if (userStr) return JSON.parse(userStr);
  else return null;
};

// return the token from the session storage
export const getToken = () => {
  migrateKurdishTalentPublicAuth();
  return localStorage.getItem(KT_AUTH_TOKEN_KEY) || null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  localStorage.removeItem(KT_AUTH_TOKEN_KEY);
  localStorage.removeItem(KT_AUTH_USER_KEY);
  try {
    sessionStorage.removeItem("kt_participant_profile_v1");
  } catch (_) {
    /* ignore */
  }
};

export const getDefaultName = (item_names, field = "name") => {
  const language_id = getCurrentLanguageId();

  if (!item_names || !item_names.length) {
    return "";
  }

  const default_name = item_names.find((x) => x.language == language_id);
  if (default_name) {
    const v = default_name[field];
    if (v !== undefined && v !== null) {
      return v;
    }
    if (field !== "name" && default_name.name !== undefined && default_name.name !== null) {
      return default_name.name;
    }
  }

  const first = item_names[0];
  if (!first) {
    return "";
  }
  const fv = first[field];
  if (fv !== undefined && fv !== null) {
    return fv;
  }
  return first.name ?? "";
};



export const getDefaultValue = (translate) => {
  let language_id = getCurrentLanguageId();

  if (translate.values) {
    var default_value = translate.values.find((x) => x.language?.id>0 ? x.language.id == language_id : x.language == language_id);
    if (default_value) return default_value.value;
    else return "#"+translate.key;
  }
  return "#"+translate.key;
};
export const getName = (item_names) => {
  let language_id = getCurrentLanguageId();

  if (item_names) {
    var default_name = item_names.find((x) => x.language == language_id);
    if (default_name) return default_name;
    else return item_names[0];
  }
  return "";
};

export const getDefaultDescription = (item_names) => {
  let language_id = getCurrentLanguageId();

  if (item_names) {
    var default_name = item_names.find((x) => x.language == language_id);
    if (default_name)
      return parse(default_name.description ? default_name.description : "");
    else
      return parse(item_names[0].description ? item_names[0].description : "");
  }
  return "";
};

/** Per-language tutorial video path or URL from document `names` (see CMS talent document). */
export const getDefaultTutorialVideo = (item_names) => {
  const language_id = getCurrentLanguageId();
  if (!item_names || !item_names.length) return "";
  const entry =
    item_names.find((x) => x.language == language_id) || item_names[0];
  return entry && entry.tutorial_video ? entry.tutorial_video : "";
};

// set the token and user from the session storage
export const setUserSession = (token, user) => {
  localStorage.setItem(KT_AUTH_TOKEN_KEY, token);
  localStorage.setItem(KT_AUTH_USER_KEY, JSON.stringify(user));
};
const THEME_STORAGE_KEY = "theme";
const THEME_DARK = "dark";
const THEME_LIGHT = "light";

const readStoredTheme = () => {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) === THEME_LIGHT
      ? THEME_LIGHT
      : THEME_DARK;
  } catch (_) {
    return THEME_DARK;
  }
};

const writeStoredTheme = (theme) => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (_) {
    /* ignore quota / private mode */
  }
};

const applyHtmlTheme = (theme) => {
  const root = document.documentElement;
  if (!root) return;
  if (theme === THEME_LIGHT) {
    root.classList.remove("dark");
    root.style.colorScheme = "light";
  } else {
    root.classList.add("dark");
    root.style.colorScheme = "dark";
  }
};

export const changeTheme = (e) => {
  if (e && e.preventDefault) e.preventDefault();
  const theme = readStoredTheme() === THEME_DARK ? THEME_LIGHT : THEME_DARK;
  writeStoredTheme(theme);
  applyHtmlTheme(theme);
  return theme;
};
export const getTheme = () => {
  return readStoredTheme() === THEME_DARK ? "Light Theme" : "Dark Theme";
};
export const getSelectedTheme = () => {
  return readStoredTheme();
};
export const setTheme = () => {
  const theme = readStoredTheme();
  writeStoredTheme(theme);
  applyHtmlTheme(theme);
};

export const isImage = (path) => {
  if (!path) return false;

  var fileType = path.split(".").pop();
  var validImageTypes = [
    "gif",
    "GIF",
    "jpeg",
    "JPEG",
    "jpg",
    "JPG",
    "png",
    "PNG",
  ];
  if (validImageTypes.includes(fileType)) {
    return true;
  } else return false;
};
export const isVideo = (path) => {
  var fileType = path.split(".").pop();
  var validImageTypes = ["mp4", "mov", "wmv", "AMI", "AVI"];
  if (validImageTypes.includes(fileType)) {
    return true;
  } else return false;
};

export const Mg = (value) => {
  if (parseFloat(value) > 0)
    return Math.round(parseFloat(parseFloat(value) / (1024 * 1024)), 3);
  else return value;
};

export const isDocument = (path) => {
  if(!path) return false;
  var fileType = path.split(".").pop();
  var validImageTypes = ["pdf", "doc", "docx", "txt"];
  if (validImageTypes.includes(fileType)) {
    return true;
  } else return false;
};
export const isYoutube = (path) => {
  if(!path) return false;
  if (path.includes("youtube.com") || path.includes("youtu.be")) return true
  return false

};

/** Hosted video file (Firebase Storage or S3 / CloudFront). */
export const isDirectVideoFileUrl = (url) => {
  if (!url) return false;
  return (
    url.includes("firebasestorage") ||
    url.includes(".amazonaws.com") ||
    url.includes("cloudfront.net")
  );
};

export const getFileName = function (str) {
  return str.replace(/^.*(\\|\/|\:)/, "");
};



export const getYoutubeId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return (match && match[2].length === 11)
      ? match[2]
      : null;
}

export const toTime = function (time) {
  var minutes = Math.floor(time / 60);
  var seconds = time - minutes * 60;
  if (minutes + seconds > 0) return minutes + ":" + seconds;
  else return "";
};

export const getCourseNames = function (str_courses) {
  if (!str_courses) return "";
  return "";
  var ids = str_courses.split(",");
  if (ids && ids.length > 0) {
    ids.map((item, index) => {
      loadCourse(item).then((course) => {
        return (
          "This document used in a competition : " +
          getDefaultName(course.names)
        );
      });
    });
  }
  return "";
};

export const BuildTalents = (talents, active_only) => {
  if (talents && talents.code) {
    window.location.href = "signout";
  }

  if (talents) {
    var parents = [];

    if (active_only) parents = talents.filter((x) => !x.parent && x.status);
    else parents = talents.filter((x) => !x.parent);

    parents.forEach((parent) => {
      parent.childs = getChilds(talents, parent.id, active_only);
    });

    return parents;
  }
};

export const getDate = (dateString) => {
  var dateObject = new Date(dateString);
  return dateObject.toDateString();
};
export const getYearMonth = (dateString) => {
  if (!dateString) return dateString;
  var dateObject = new Date(dateString);
  const month = dateObject.toLocaleString("default", { month: "short" });
  return dateObject.getFullYear() + " " + month;
};
export const getYear = (dateString) => {
  var dateObject = new Date(dateString);
  return dateObject.getFullYear();
};
export const getDay = (dateString) => {
  var dateObject = new Date(dateString);
  return dateObject.getDay();
};

export const getMonth = (dateString) => {
  var dateObject = new Date(dateString);
  const month = dateObject.toLocaleString("default", { month: "short" });

  return month;
};
export const getChilds = (all_talents, talent_id, active_only) => {
  var childs = [];
  if (active_only)
    childs = all_talents.filter((x) => x.parent === talent_id && x.status);
  else childs = all_talents.filter((x) => x.parent === talent_id);

  childs.forEach((item) => {
    item.childs = getChilds(all_talents, item.id, active_only);
  });
  return childs;
};
export function sortCities(array) {
  return array.sort(function (a, b) {
    //console.log(a["names"][0])

    var x = a["names"][0]["name"];
    var y = b["names"][0]["name"];
    return x < y ? -1 : x > y ? 1 : 0;
  });
}
export function getExtension(file_name) {
  if (file_name) return file_name.split(".").pop().toLowerCase();
}

export function sortByKey(array, key) {
  return array.sort(function (a, b) {
    //console.log(a["names"][0])
    var x = a["names"][0]["name"];
    var y = b["names"][0]["name"];

    return x < y ? -1 : x > y ? 1 : 0;
  });
}

export function days_between(date1, date2) {
  //console.log(date1,date2)
  // The number of milliseconds in one day
  const ONE_DAY = 1000 * 60 * 60 * 24;

  // Calculate the difference in milliseconds
  const differenceMs = Math.abs(date1 - date2);

  // Convert back to days and return
  return Math.round(differenceMs / ONE_DAY);
}

export const setCurrentLanguage = (language,change_direction=true) => {
  
  localStorage.setItem("language", language);
  //document.cookie = `language=${language}`

  if (change_direction)
    if (language === "so")
      document.getElementsByTagName("html")[0].classList.add("rtl");
    else document.getElementsByTagName("html")[0].classList.remove("rtl");
};
export const getCurrentLanguageId = () => {
  let lang = localStorage.getItem("language");
  //let lang = readCookie("language")
  if (!lang) return 3;

  if (lang === "en") return 3;
  if (lang === "so") return 2;
  if (lang === "ku") return 1;

  return lang;
};


export const changeLanguage = (e, lang) => {
  e.preventDefault();
  setCurrentLanguage(lang,false);
  window.location.href =
    window.location.origin + window.location.pathname + `?lang=${lang}`;
};

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  //var ca = localStorage.getItem("language")?.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export const getCurrentLanguage = () => {
  let lang = localStorage.getItem("language");

  //let lang = readCookie("language");
  if (!lang) lang = "en";
  if (lang === "so")
    document.getElementsByTagName("html")[0].classList.add("rtl");
  else document.getElementsByTagName("html")[0].classList.remove("rtl");
  return lang;
};

export async function readLanguageFile() {
  const lang = getCurrentLanguage();
  var file = "";
  if (lang === "so") {
    file = `assets/so.json`;
  } else if (lang === "ku") {
    file = `assets/ku.json`;
  }

  

  if (file) {
    const response = await fetch(file, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    const data = await response.json();

    return data;
  } else return null;
}
export const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export const setPublicVoteCookie=()=>{
  let random = (Math.random() + 1).toString(36).substring(7);
  localStorage.setItem('pvc', random);
  return random;
}

export const getPublicVoteCookie=()=>{
  return localStorage.getItem('pvc');
}

export const translate = (translations,str) => {
  if (!translations) return str;
  var translate = translations.find(x=>x.key == str );

  if (translate) return getDefaultValue(translate);
  else return "#" + str;
};

export const userAvatar = (profile) => {
  let res = "/assets/images/user.png";
  if(profile){
    if(profile?.avatar){
      res = resolveMediaUrl(profile.avatar);
    } else if (profile?.image) {
      res = resolveMediaUrl(profile.image);
    }
  }
  return res;
};

export const userImage = (profile) => {
  let res = "/assets/images/user.png";
  if(profile){
    if(profile?.image){
      res = resolveMediaUrl(profile.image);
    } else if (profile?.avatar) {
      res = resolveMediaUrl(profile.avatar);
    }
  }
  return res;
};

